
class Threshold {
  constructor(rdg, label, min, max, term, good, bad, crit, bad2, crit2){
    this.rdg = rdg;
    this.label = label;
    this.min = min;
    this.max = max;
    this.term = term;
    this.good = good;
    this.bad = bad;
    this.crit = crit;
    if (bad2) this.bad2 = bad2;
    if (crit2) this.crit2 = crit2;
  }
}

export default {
  days: new Threshold('days', 'Days Remaining', 0, 1000, 'days', {min: 20, max: 1000}, {min: 7, max: 19}, {min: 0, max: 6}),
  ttp: new Threshold('ttp', 'Temperature', -20, 50, '˚', {min: 19, max: 24}, {min: 25, max: 32}, {min: 33, max: 50}, {min: 10, max: 18}, {min: -40, max: 9}),
  hhm: new Threshold('hhm', 'Humidity', 0, 100, '%', {min: 20, max: 40}, {min: 41, max: 70}, {min: 71, max: 100}, {min: 10, max: 19}, {min: 0, max: 9}),
  voc: new Threshold('voc', 'tVOC', 0, 80000, '', {min: 0, max: 100000}, {min: 10001, max: 150000}, {min: 150001, max: Infinity}),
  co2: new Threshold('co2', 'CO2', 0, 10000, 'ppm', {min: 0, max: 750}, {min: 751, max: 1000}, {min: 1001, max: Infinity})
}



// WEBPACK FOOTER //
// ./src/lib/spiderThresh.js